import { render, staticRenderFns } from "./AdminVehicleDetails.vue?vue&type=template&id=1f2fd902&scoped=true"
import script from "./AdminVehicleDetails.vue?vue&type=script&lang=js"
export * from "./AdminVehicleDetails.vue?vue&type=script&lang=js"
import style0 from "./AdminVehicleDetails.vue?vue&type=style&index=0&id=1f2fd902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2fd902",
  null
  
)

export default component.exports